<template>
  <div v-if="$store.getters['event/isLoaded']">
    <TopBar id="topBar"></TopBar>
    <div class="content-container">
      <SelectionEpreuve @onLoadStart="loading= true" @onLoadEnd="loading=false"></SelectionEpreuve>
    </div>
    <div class="content-container" v-if="$store.getters['event/showFilterBar']">
      <FiltersResultsBar></FiltersResultsBar>
    </div>


    <div class="content-container">
      <h5 class="ml-2 mt-2 text-darkorange"><b>{{ $store.getters['event/titleResults'] }}</b></h5>
      <FullScreenLoading v-if="loading" action="Chargement en cours"></FullScreenLoading>
      <TableauResultatsChallenge id="tableau-resultats" v-else-if="$store.getters['event/showChallengeResults']">
      </TableauResultatsChallenge>
      <TableauResultatsChallengeEquipe id="tableau-resultats"
        v-else-if="$store.getters['event/showChallengeEquipeResults']"></TableauResultatsChallengeEquipe>
      <TableauResultatsCourseCumul id="tableau-resultats" v-else-if="$store.getters['event/showCoursesCumulResults']">
      </TableauResultatsCourseCumul>
      <TableauResultatsCourseCumulEquipe id="tableau-resultats"
        v-else-if="$store.getters['event/showCoursesCumulEquipeResults']"></TableauResultatsCourseCumulEquipe>
      <TableauResultats id="tableau-resultats" v-else-if="$store.getters['event/showDefaultResults']">
      </TableauResultats>
      <TableauResultatsPassages v-else-if="$store.getters['event/showPassagesResults']"></TableauResultatsPassages>
      <TableauResultatsEquipe id="tableau-resultats" v-else-if="$store.getters['event/showTeamResults']">
      </TableauResultatsEquipe>

      <AttenteResultats v-if="!loading && !$store.getters['event/has_results']"></AttenteResultats>

    </div>



  </div>
</template>

<script>
import TopBar from "@/component/Epreuve/TopBar";
import SelectionEpreuve from "@/component/Epreuve/SelectionEpreuve.vue";
import TableauResultats from "@/component/Epreuve/TableauResultats";
import TableauResultatsPassages from "@/component/Epreuve/TableauResultatsPassages";
import TableauResultatsEquipe from "@/component/Epreuve/TableauResultatsEquipe";
/* import SelectionCourse from "@/component/Epreuve/SelectionCourse";
import SelectionChallenge from "@/component/Epreuve/SelectionChallenge";
import SelectionRassemblement from "@/component/Epreuve/SelectionRassemblement";
import SelectionChallengeEquipe from "@/component/Epreuve/SelectionChallengeEquipe"; */
import FullScreenLoading from "@/component/FullScreenLoading";
import AttenteResultats from "@/component/Epreuve/AttenteResultats";
/* import SelectPointIntermediaires from "@/component/Epreuve/SelectPointIntermediaires";
import SelectionCourseCumul from "@/component/Epreuve/SelectionCourseCumul";
import SelectionCourseCumulEquipe from "@/component/Epreuve/SelectionCourseCumulEquipe"; */
import DownloadSelectionSection from "@/component/Epreuve/DownloadSelectionSection";
import FiltersResultsBar from "@/component/Epreuve/FiltersResultsBar";
import TableauResultatsChallenge from "../component/Epreuve/TableauResultatsChallenge.vue";
import TableauResultatsChallengeEquipe from "../component/Epreuve/TableauResultatsChallengeEquipe.vue";
import TableauResultatsCourseCumul from "../component/Epreuve/TableauResultatsCourseCumul.vue";
import TableauResultatsCourseCumulEquipe from "../component/Epreuve/TableauResultatsCourseCumulEquipe.vue";


export default {
  components: {
    TopBar,
    TableauResultats,
    TableauResultatsPassages,
    TableauResultatsEquipe,
/*     SelectionCourse,
    SelectionRassemblement,
    SelectionChallenge, */
    FullScreenLoading,
    AttenteResultats,
    /*SelectPointIntermediaires,
     SelectionChallengeEquipe,
    SelectionCourseCumul,
    SelectionCourseCumulEquipe, */
    DownloadSelectionSection,
    FiltersResultsBar,
    SelectionEpreuve,
    TableauResultatsChallenge,
    TableauResultatsChallengeEquipe,
    TableauResultatsCourseCumul,
    TableauResultatsCourseCumulEquipe,

  },

  data() {
    return {
      loading: true,
    };
  },

  methods: {
    async initView() {
      this.loading = true;
      const query = this.$route.query;
      this.$store.dispatch("event/init", query);
      await this.$store.dispatch("event/fetch");
      this.loading = false;
    },
  },
  async mounted() {
    await this.initView();
  },
};
</script>

<style>

</style>
